import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-driver',
  templateUrl: './driver.component.html',
  styleUrls: ['./driver.component.less']
})
export class DriverComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
